export default function getResource(label, vars = []) {
    const resources = { moreCleanBeautyTitle: 'More Clean Beauty' };
    return resources[label];
}
